'use client';

// npm packages
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';

// components
import { copyToClipboard } from '@/utils';
import Button from '../Button';
import Icon from '../Icon';
import Text from '../Text';
import ImageComponentV2 from '../Image/ImageComponentV2';

// utils

const socialMedia = [
  {
    id: 'whatsapp',
    image: '/icons/whatsapp.svg',
  },
  {
    id: 'messenger',
    image: '/icons/messenger.svg',
  },
  {
    id: 'facebook',
    image: '/icons/facebook.svg',
  },
  {
    id: 'instagram',
    image: '/icons/instagram.svg',
  },
  {
    id: 'linkedin',
    image: '/icons/linkedin.svg',
  },
];

function ShareJobLinkModal({ data, onView, onClose }) {
  const [openModal, setOpenModal] = useState(onView);
  const modalRef = useRef(null);
  const [jobUrl, setJobUrl] = useState(
    'https://singerbangladesh.com/career/description/j19jpq',
  );

  const handleClose = () => {
    setOpenModal(false);
    onClose(false);
  };

  const handleClipboardCopy = () => {
    if (jobUrl !== null) {
      copyToClipboard(jobUrl);
      alert('Copied to clipboard!');
    }
  };

  useEffect(() => {
    if (onView) {
      setTimeout(() => {
        setOpenModal(true);
        document.body.style.overflow = 'hidden';
      }, 100);
    } else {
      setOpenModal(false);
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [onView]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
      }
    };

    if (openModal) {
      document.addEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [openModal]);

  return (
    <div
      className={classNames(
        'w-full h-full bg-black/50 flex items-center justify-center invisible z-[501] opacity-30 transition-all duration-100 fixed inset-0',
        {
          '!opacity-100 !visible': openModal,
        },
      )}
    >
      <div
        ref={modalRef}
        className={classNames(
          `w-full max-w-[480px] mx-8 px-16 lg:px-24 py-10 lg:py-24 relative rounded-[4px] lg:rounded-[12px] transition-all duration-[10ms]`,
        )}
      >
        <div className="mb-12">
          <Icon
            type="close"
            color="#fff"
            onClick={handleClose}
            className="cursor-pointer ml-auto"
          />
        </div>
        <div className="bg-white p-16 rounded-xl shadow-cannot-be-added-modal">
          <Text
            type="sub_title"
            className="text-coarse-wool text-14 lg:text-16 font-encode-sans font-medium leading-20 tracking-[0.28px] lg:tracking-[0.32px] mb-8"
          >
            Share this link via
          </Text>
          <div className="flex items-center gap-[16px] mb-20">
            {socialMedia?.map((item, index) => (
              <ImageComponentV2
                key={item?.id}
                src={item?.image}
                sizes="100vw"
                style={{
                  width: 'auto',
                  height: 'auto',
                  maxWidth: '100%',
                  maxHeight: '100%',
                }}
                width={500}
                height={300}
                alt={item?.id}
                loading="lazy"
              />
            ))}
          </div>
          <Text
            type="sub_title"
            className="text-coarse-wool text-14 lg:text-16 font-encode-sans font-medium leading-20 tracking-[0.28px] lg:tracking-[0.32px] mb-4"
          >
            0r, Copy link
          </Text>
          <div className="w-full h-[38px] lg:h-[44px] flex items-center justify-center bg-white p-4 border border-himalayan-poppy rounded-[28px] 3xl:rounded-[100px] gap-4">
            <input
              className="w-full border-none bg-transparent pl-8 py-1 text-gunmetal text-12 font-semibold font-encode-sans leading-16 tracking-[0.24px] outline-none focus:outline-none line-clamp-1"
              type="text"
              name="link"
              value={jobUrl}
              readOnly
              // onChange={(e) => handleStoreAddressInput(e)}
              placeholder="https://singerbangladesh.com/career/description/j19jpq"
            />
            <Button
              type="outline"
              className="bg-aquarelle-purple !px-12 !py-8 !border-tealgreen rounded-[100px]"
              onClick={handleClipboardCopy}
            >
              <Text
                type="sub_title"
                className="text-tealgreen text-12 lg:text-16 font-encode-sans font-semibold leading-14 lg:leading-20 tracking-[0.24px] lg:tracking-[0.32px]"
              >
                Copy
              </Text>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShareJobLinkModal;
